export default __webpack_public_path__ + "static/media/activity.6b4ceb0f.png";